import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EmailHistoryList } from "../../components/emailhistory/EmailHistoryList";
// import { UrlForwardList } from "../../components/urlforward/UrlForwardList";

// Add Translation
export const EmailHistory: React.FC = () => {
  const { t } = useTranslation();


  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.emails")}
        // extra={<Button
        //   key="email_history"
        //   type="primary"
        //   icon={<PlusIcon />}

        // >
        //   {t("main_menu.email_history")}
        // </Button>}
        />
      }
    >
      <EmailHistoryList />

    </MainContentArea>
  );
};
